import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('FORUM_COMMENT').plugin(axiosPlugin);

let fetchForumCommentAction = redux.fetchActionGetOne();

let createForumCommentAction = redux.fetchActionCreate();

let updateForumCommentAction = redux.fetchActionUpdate();

let deleteForumCommentAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const fetchForumComment = (forumId, topicId, commentId, query = {}) => fetchForumCommentAction(`/forums/${forumId}/topics/${topicId}/comments/${commentId}?${queryString.stringify(query)}`);
export const createForumComment = (forumId, topicId, data) => createForumCommentAction(`/forums/${forumId}/topics/${topicId}/comments`, data);
export const updateForumComment = (forumId, topicId, commentId, data) => updateForumCommentAction(`/forums/${forumId}/topics/${topicId}/comments/${commentId}`, data);
export const deleteForumComment = (forumId, topicId, commentId = {}) => deleteForumCommentAction(`/forums/${forumId}/topics/${topicId}/comments/${commentId}`);
export const resetForumComment = () => redux.actions.reset();

export const forumComment = redux.reducer();